import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { User } from 'types/user';

type UserItemModuleProps = {
  user: User;
};

const UserItemModule: React.FC<UserItemModuleProps> = ({ user }) => {
  return (
    <ModuleCard
      idLabel={`ID ${user.id}`}
      title={user.name}
      subtitle={user.username}
      status={user.formattedActive}
      statusTone={user.active ? 'success' : 'error'}
      fields={[
        { label: 'CPF', value: user.document_number },
        { label: 'RG', value: user.rg },
        { label: 'E-mail', value: user.email },
        { label: 'Telefone', value: user.phone },
        { label: 'Perfil', value: user.formattedProfileName },
      ]}
      onClick={() => history.push(`/users/${user.id}`)}
    />
  );
};

export default UserItemModule;
